import React from 'react';
import ReactDOM from 'react-dom/client';

const path = window.location.pathname;

async function boot() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  if (path.startsWith('/admin')) {
    const { default: AdminApp } = await import('./admin/AdminApp');
    root.render(<React.StrictMode><AdminApp /></React.StrictMode>);
  } else if (path.startsWith('/app')) {
    const { default: App } = await import('./App');
    root.render(<React.StrictMode><App /></React.StrictMode>);
    const { register } = await import('./serviceWorkerRegistration');
    register();
  } else {
    const { default: PublicMapApp } = await import('./public-map/PublicMapApp');
    root.render(<React.StrictMode><PublicMapApp /></React.StrictMode>);
  }
}

boot();
